<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.return_warehouse") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-md-4">
                <base-input :label="$t('wms.storage')">
                  <el-select
                    v-model="StorageID"
                    :placeholder="$t('wms.storage')"
                  >
                    <el-option
                      v-for="option in Storage"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input
                  :label="$t('search')"
                  v-model="SearchKeyword"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
          </template>

          <div>
            <el-table
              :data="queriedData"
              row-key="ID"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
            >
              <el-table-column
                prop="ProductName"
                :label="$t('wms.product')"
                min-width="160px"
                sortable
              >
              </el-table-column>
              <el-table-column
                prop="Balance"
                :label="$t('wms.return_available')"
                min-width="120px"
                sortable
              >
              </el-table-column>

              <el-table-column
                min-width="220px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ row }" class="d-flex">
                  <base-button
                    @click.native="handleOpenMove(row)"
                    class="edit"
                    type="primary"
                    size="sm"
                    :disabled="row.Balance <= 0"
                  >
                    <i class="fa fa-dolly"></i>
                    {{ $t("wms.return_move_title") }}
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <!-- Move to retail pack room modal -->
    <modal :show.sync="showMoveModal" modal-classes="modal-secondary">
      <h6 slot="header" class="modal-title">
        {{ $t("wms.return_move_title") }}
      </h6>

      <form class="new-event--form" @submit.prevent="handleMove">
        <base-input :label="$t('wms.product')">
          <p class="form-control-static">{{ move.ProductName }}</p>
        </base-input>

        <base-input :label="$t('wms.return_available')">
          <p class="form-control-static">{{ move.Balance }}</p>
        </base-input>

        <base-input
          v-model="move.Quantity"
          type="number"
          :min="1"
          :max="move.Balance"
          :label="$t('wms.return_move_qty')"
          input-classes="form-control-alternative"
        >
        </base-input>
        <small v-if="isExceed" class="text-danger">
          {{ $t("wms.return_move_exceed") }}
        </small>

        <base-input
          v-model="move.Note"
          :label="$t('wms.note')"
          input-classes="form-control-alternative"
        >
        </base-input>
      </form>

      <template slot="footer">
        <base-button
          type="primary"
          :loading="isLoading"
          :disabled="!isValidQty"
          @click="handleMove()"
        >
          {{ $t("save") }}
        </base-button>
        <base-button type="link" class="ml-auto" @click="showMoveModal = false">
          {{ $t("cancel") }}
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

// Default storage id for the return warehouse (config.yml
// app.storage_for_order_return_good = 13). Used only to pre-select the
// storage filter; the move endpoint resolves the warehouse server-side.
const RETURN_STORAGE_ID = 13;

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getData",
      Storage: "WmsStorage/getData",
    }),
    tableData: function () {
      return this.tableDataOrg.filter((d) => {
        let matchStorage = d.StorageID == this.StorageID;
        if (this.SearchKeyword == "") {
          return matchStorage;
        }
        let kw = this.SearchKeyword.toLowerCase();
        return (
          matchStorage &&
          ((d.ProductName &&
            d.ProductName.toLowerCase().indexOf(kw) != -1) ||
            (d.Barcode && d.Barcode.indexOf(this.SearchKeyword) != -1))
        );
      });
    },
    isExceed: function () {
      let qty = parseInt(this.move.Quantity);
      return !isNaN(qty) && qty > this.move.Balance;
    },
    isValidQty: function () {
      let qty = parseInt(this.move.Quantity);
      return !isNaN(qty) && qty >= 1 && qty <= this.move.Balance;
    },
  },
  data() {
    return {
      isLoading: false,
      StorageID: RETURN_STORAGE_ID,
      SearchKeyword: "",
      showMoveModal: false,
      move: {
        ProductID: 0,
        ProductName: "",
        Balance: 0,
        Quantity: 0,
        Note: "",
      },
    };
  },
  mounted() {
    this.pagination.perPage = 10;
    this.listStorage();
    this.listData();
    this.resolveReturnStorage();
  },
  methods: {
    ...mapActions({
      listData: "WmsInventory/listData",
      listStorage: "WmsStorage/listData",
      InventoryMoveReturnToRetail: "WmsInventory/InventoryMoveReturnToRetail",
    }),
    // Prefer matching the storage by name (handles ids that differ across
    // enterprises) and fall back to the configured default id.
    resolveReturnStorage() {
      let match = this.Storage.find((s) => {
        let name = (s.Name || "").toLowerCase();
        return name.indexOf("ตีกลับ") != -1 || name.indexOf("return") != -1;
      });
      if (match) {
        this.StorageID = match.ID;
      }
    },
    handleOpenMove(row) {
      this.move.ProductID = parseInt(row.ProductID);
      this.move.ProductName = row.ProductName;
      this.move.Balance = parseInt(row.Balance);
      this.move.Quantity = parseInt(row.Balance);
      this.move.Note = "";
      this.showMoveModal = true;
    },
    handleMove() {
      if (!this.isValidQty) {
        return;
      }
      this.isLoading = true;

      let payload = {
        list: [
          {
            product_id: this.move.ProductID,
            quantity: parseInt(this.move.Quantity),
          },
        ],
        note: this.move.Note,
      };

      this.InventoryMoveReturnToRetail(payload)
        .then((resp) => {
          this.isLoading = false;
          this.showMoveModal = false;
          this.listData();
          swal.fire({
            title: this.$t("wms.return_move_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        })
        .catch((err) => {
          this.isLoading = false;
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: err.response.data.Cause,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
    },
  },
  watch: {
    Storage: function () {
      this.resolveReturnStorage();
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
